/**
 * Spades in words, the three languages side by side (review 0027 B6): a game's strings live in the
 * game's own file, as Hearts' and King's do, so the language files stay in budget as games arrive.
 */
export const spadesEn = {
  "spades.bid.title": "Your bid",
  "spades.bid.nil": "Nil",
  "spades.bid.aside": "Team so far: {bid}",
  "spades.seat.bid": "bid {amount}",
  "spades.seat.nil": "Nil",
  "spades.team.us": "Us",
  "spades.team.them": "Them",
  "spades.bags": "{bags} {bags|bag|bags}",
  "spades.event.bids-done": "Bids are in",
  "spades.event.nil-made": "{name} made nil",
  "spades.event.nil-failed": "{name} broke nil",
  "spades.event.hand-scored": "Hand scored: us {us}, them {them}",
  "spades.handEnd": "Us {us} · Them {them}",
  "spades.toast.team": "Bid {bid} · {tricks} {tricks|trick|tricks} · {bags} {bags|bag|bags}",
} as const;

type SpadesKey = keyof typeof spadesEn;

export const spadesTr: Record<SpadesKey, string> = {
  "spades.bid.title": "İhalen",
  "spades.bid.nil": "Nil",
  "spades.bid.aside": "Takım şu ana kadar: {bid}",
  "spades.seat.bid": "ihale {amount}",
  "spades.seat.nil": "Nil",
  "spades.team.us": "Biz",
  "spades.team.them": "Onlar",
  "spades.bags": "{bags} bag",
  "spades.event.bids-done": "İhaleler tamam",
  "spades.event.nil-made": "{name} nil tuttu",
  "spades.event.nil-failed": "{name} nil bozdu",
  "spades.event.hand-scored": "El puanlandı: biz {us}, onlar {them}",
  "spades.handEnd": "Biz {us} · Onlar {them}",
  "spades.toast.team": "İhale {bid} · {tricks} el · {bags} bag",
};

export const spadesAr: Record<SpadesKey, string> = {
  "spades.bid.title": "طلبك",
  "spades.bid.nil": "نيل",
  "spades.bid.aside": "طلب الفريق حتى الآن: {bid}",
  "spades.seat.bid": "طلب {amount}",
  "spades.seat.nil": "نيل",
  "spades.team.us": "نحن",
  "spades.team.them": "هم",
  "spades.bags": "{bags} {bags|one:زيادة|two:زيادتان|few:زيادات|other:زيادة}",
  "spades.event.bids-done": "اكتملت الطلبات",
  "spades.event.nil-made": "{name} نجح في النيل",
  "spades.event.nil-failed": "{name} كسر النيل",
  "spades.event.hand-scored": "نتيجة الجولة: نحن {us}، هم {them}",
  "spades.handEnd": "نحن {us} · هم {them}",
  "spades.toast.team":
    "الطلب {bid} · {tricks} {tricks|one:أكلة|two:أكلتان|few:أكلات|other:أكلة} · {bags} {bags|one:زيادة|two:زيادتان|few:زيادات|other:زيادة}",
};
